import { render, staticRenderFns } from "./handItem.vue?vue&type=template&id=0ebc46ff"
import script from "./handItem.vue?vue&type=script&lang=js"
export * from "./handItem.vue?vue&type=script&lang=js"
import style0 from "./handItem.vue?vue&type=style&index=0&id=0ebc46ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports